import { AppMode } from '@ftr/contracts/api/user'
import { isUUID } from 'class-validator'

const ROUTES_WITHOUT_SIDE_NAV = [
  '/login',
  '/signup',
  '/reset',
  '/reset-sent',
  '/resetverify',
  '/multifactor-authentication',
  '/recover-account',
  '/confirmation-sent',
  '/verification',
]

const FULL_ROUTES_WITHOUT_SIDE_NAV = ['/download']

export function hasSideNavigation(url: string, appMode: AppMode): boolean {
  const urlWithoutQueryParams = url.split('?').at(0) ?? ''
  const urlToCompare = urlWithoutQueryParams
    .split('/')
    .filter(segment => !isUUID(segment))
    .join('/')
  const isOnHomePage = urlToCompare === '/'
  if (appMode === 'portal' && isOnHomePage) {
    return false
  }
  return (
    !ROUTES_WITHOUT_SIDE_NAV.some(routeWithoutNav => urlToCompare.endsWith(routeWithoutNav)) &&
    !FULL_ROUTES_WITHOUT_SIDE_NAV.some(routeWithoutNav => urlToCompare === routeWithoutNav)
  )
}
